import styled, { useTheme } from 'styled-components'
import Modal from '@/components/common/modals/Modal'
import { Typo, TypoVariant } from '@/components/common/typography'
import { useCustomRouter } from '@/containers/hooks'
import { ProductType } from '@/graphql/generated/schemas'

type ActionPowerInvalidOrderItemModalProps = {
  isInvalidOrderItems: boolean
  actionPowerProducts: Pick<ProductType, 'name'>[]
}

const ActionPowerInvalidOrderItemModal = ({
  isInvalidOrderItems,
  actionPowerProducts,
}: ActionPowerInvalidOrderItemModalProps) => {
  const { color } = useTheme()
  const { back } = useCustomRouter()

  return (
    <Modal open={isInvalidOrderItems}>
      <Modal.Content>
        <Modal.Title>
          <Typo variant={TypoVariant.Heading6Bold} color={color.gray900}>
            구매 수량을 확인해 주세요
          </Typo>
        </Modal.Title>
        <Modal.SubTitle>
          <Typo variant={TypoVariant.Body3Regular} color={color.gray700}>
            아래 상품은 1개씩만 구매가 가능해요
          </Typo>
        </Modal.SubTitle>
        <StyledModalProductList>
          {actionPowerProducts.map(({ name }) => (
            <Typo key={name} as="p" variant={TypoVariant.Body4Regular} color={color.gray700}>
              {name}
            </Typo>
          ))}
        </StyledModalProductList>
      </Modal.Content>
      <Modal.Footer>
        <ModalButton className="ok" onClick={back}>
          <Typo variant={TypoVariant.Body1Bold} color={color.grayWhite}>
            돌아가서 수량 조절하기
          </Typo>
        </ModalButton>
      </Modal.Footer>
    </Modal>
  )
}

const StyledModalProductList = styled.div`
  margin-top: 1.6rem;
  border-radius: 8px;
  padding: 1.6rem;
  background-color: ${({
    theme: {
      color: { gray50 },
    },
  }) => gray50};
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  p {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    &::before {
      content: '';
      background-color: ${({
        theme: {
          color: { gray700 },
        },
      }) => gray700};
      width: 0.3rem;
      height: 0.3rem;
    }
  }
`

const ModalButton = styled.button`
  flex: 1;
  border-radius: 0.8rem;
  border: 0.1rem solid;
  padding: 1.3rem 1.6rem;
  cursor: pointer;
  width: 100%;

  &.ok {
    border-color: ${({ theme }) => theme.color.blue500};
    background-color: ${({ theme }) => theme.color.blue500};
  }
`

export { ActionPowerInvalidOrderItemModal }
